import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";

import { getAutomationDataAttr } from "../../../utils/automationUtils";

import "./styles.scss";

const InputError = ({ children, classes, style, testId, ...rest }) => {
  let classNames = "InputError ";

  if (classes) {
    classNames += classes;
  }

  return (
    <span
      className={classNames}
      style={style}
      {...getAutomationDataAttr(testId)}
      {...testLocator(testId)}
      {...rest}
    >
      {children}
    </span>
  );
};

export default InputError;
